import { api } from "@/api/axios.ts";
import {
  ApiCompensationComponent,
  ApiCompensationComponentPayload,
} from "@/types/compensation-component.types.ts";
import { ApiOperationResult } from "@/types/common.types.ts";

export const apiCompensationComponents = {
  getAll() {
    return api.get<ApiCompensationComponent[]>("/api/v1/compensation-components");
  },
  create(payload: ApiCompensationComponentPayload) {
    return api.post<ApiCompensationComponent>("/api/v1/compensation-components", payload);
  },
  update(id: number, payload: ApiCompensationComponentPayload) {
    return api.put<ApiCompensationComponent>(`/api/v1/compensation-components/${id}`, payload);
  },
  updateSort(ids: number[]) {
    return api.put<ApiOperationResult>("/api/v1/compensation-components/sort", { ids });
  },
  archive(id: number) {
    return api.delete<ApiOperationResult>(`/api/v1/compensation-components/${id}`);
  },
};
